"use client";

import { Button } from "@/components/frontend/ui/button";
import { useFavorites } from "@/contexts/frontend/favorites-context";
import { PropertyListingType } from "@/lib/types/marketsuite/datatypes/property";
import { cn } from "@/lib/utils";
import { Heart } from "lucide-react";
import { useTranslations } from "next-intl";

interface PropertyFavoriteButtonProps {
	id: string;
	listingType: PropertyListingType;
	hideLabelMobile?: boolean;
}

export const PropertyFavoriteButton: React.FC<PropertyFavoriteButtonProps> = ({ id, listingType, hideLabelMobile = false }) => {
	const t = useTranslations("ms");
	const { toggle, has } = useFavorites();

	return (
		<Button onClick={() => toggle(id, listingType)}>
			{has(id, listingType) ? (
				<>
					<Heart className="size-4 fill-(--ms-btn-color)" />
					<span className={cn(hideLabelMobile && "hidden sm:block")}>{t("property-actions.remove-from-favorites")}</span>
				</>
			) : (
				<>
					<Heart className="size-4" />
					<span className={cn(hideLabelMobile && "hidden sm:block")}>{t("property-actions.add-to-favorites")}</span>
				</>
			)}
		</Button>
	);
};
